import { Component, computed, input } from '@angular/core';
import { ThemeSize } from '../helpers';

type HelpHeight = 'inline' | ThemeSize;

@Component({
  selector: 'app-pan-help',
  templateUrl: './pan-help.component.html',
  styleUrl: './pan-help.component.scss',
  standalone: false,
})
export class PanHelpComponent {
  public helpText = input.required<string>();
  public size = input<HelpHeight>('inline');

  public classes = computed(() => {
    return ['help', `help-size-${this.size()}`];
  });

  public helpAriaLabel = computed(() => this.helpText() || 'Help');
}
